module.exports = __webpack_public_path__ + "img/instruction-2.414b9d61.png";